<template>
    <div id="tryout-form">
        <!-- begin breadcrumb -->
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'Tryout', to: { path: '/tryouts' } },
                { text: !$route.query.id ? 'Tambah Tryout' : 'Ubah Tryout' },
            ]"
            divider="|"
        ></v-breadcrumbs>
        <!-- end breadcrumb -->
        <!-- begin page-header -->
        <h3 class="header-text font-weight-bold">
            {{ !$route.query.id ? "Tambah Tryout" : "Ubah Tryout" }}
        </h3>
        <!-- end page-header -->
        <v-card>
            <v-stepper v-model="step" flat class="pa-0" color="blew">
                <v-card-text>
                    <v-row
                        no-gutters
                        style="box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.05)"
                    >
                        <v-col cols="7">
                            <!-- begin tabs-header -->
                            <v-stepper-header flat style="box-shadow: none">
                                <v-stepper-step :complete="step > 1" step="1">
                                    Membuat Tryout
                                </v-stepper-step>

                                <v-divider></v-divider>

                                <v-stepper-step :complete="step > 2" step="2">
                                    Membuat Subtest
                                </v-stepper-step>
                                <v-divider></v-divider>

                                <v-stepper-step step="3">
                                    Preview
                                </v-stepper-step>
                                <!-- end tabs-header -->
                            </v-stepper-header>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col>
                            <!-- tryout status button, just shown when preview -->
                            <v-layout>
                                <v-flex>
                                    <v-btn
                                        v-if="
                                            statusTryout == 'REVIEW' &&
                                            step == 3
                                        "
                                        text
                                        color="grey"
                                        class="pull-right mt-5 mr-4"
                                        @click="statusTryout = 'DRAFT'"
                                    >
                                        Kembali ke Draft
                                    </v-btn>
                                </v-flex>
                                <v-flex>
                                    <v-btn
                                        v-if="
                                            statusTryout == 'REVIEW' &&
                                            step == 3
                                        "
                                        elevation="0"
                                        color="backgroundGreen"
                                        class="pull-right mt-5 mr-4 darkGreen--text"
                                        @click="statusTryout = 'PUBLISH'"
                                    >
                                        Publish Tryout
                                    </v-btn>
                                </v-flex>
                                <v-flex>
                                    <v-btn
                                        v-if="
                                            statusTryout == 'DRAFT' && step == 3
                                        "
                                        elevation="0"
                                        color="backgroundYellow"
                                        class="pull-right mt-5 mr-4 darkYellow--text"
                                        @click="statusTryout = 'REVIEW'"
                                    >
                                        Ubah ke Review
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-stepper-items>
                    <v-stepper-content step="1">
                        <!-- Tryout Items -->
                        <app-tryoutform
                            v-if="step === 1"
                            v-on:completed="goToNextStep()"
                            v-on:uncompleted="step--"
                        />
                    </v-stepper-content>

                    <v-stepper-content step="2">
                        <!-- Tryout Subtest -->
                        <app-subtestlist
                            v-on:completed="goToNextStep()"
                            v-on:uncompleted="step--"
                        />
                    </v-stepper-content>

                    <v-stepper-content step="3">
                        <!-- Tryout Review -->
                        <app-tryoutreview
                            :statusReview="statusTryout"
                            v-on:completed="goToNextStep()"
                            v-on:uncompleted="step--"
                            v-on:statusReview="statusTryout = $event"
                        ></app-tryoutreview>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>
        </v-card>
    </div>
</template>

<script>
import SubtestForm from "@/modules/tryout/components/SubtestForm";
import SubtestList from "@/modules/tryout/components/SubtestList";
import TryoutForm from "@/modules/tryout/components/TryoutForm";
import TryoutReview from "@/modules/tryout/components/Review";

export default {
    name: "tryout-wizard",

    components: {
        "app-subtestform": SubtestForm,
        "app-subtestlist": SubtestList,
        "app-tryoutform": TryoutForm,
        "app-tryoutreview": TryoutReview,
    },

    data: function () {
        return {
            step: 1,
            stepName: ["Membuat Tryout", "Membuat Subtest", "Review Tryout"],
            statusTryout: "DRAFT",
        };
    },

    methods: {
        // to change tab
        goToNextStep: function () {
            if (this.step === 3) {
                return this.$router.push({ path: "/tryouts" });
            }
            this.step++;
        },
    },

    mounted: function () {
        // get status tryout when update tryout
        if (this.$store.state.tryout.status) {
            this.statusTryout = this.$store.state.tryout.status;
        }
    },
};
</script>



// WEBPACK FOOTER //
// Form.vue?07616630